import type { Action } from 'state/actions';
import * as addonActionTypes from 'state/addonForm/addonForm.actionTypes';
import type { SponsoFeesMap } from 'state/quotes/sponsoFees/sponsoFees';
import { addOrPatchKey, removeKey, removeKeys } from 'state/utils/collection';

export function sponsoFeesReducer(state: SponsoFeesMap = {}, action: Action): SponsoFeesMap {
  switch (action.type) {
    case 'QUOTE_SPONSO_FEE':
    case addonActionTypes.ADDON_QUOTE_SPONSO_FEE:
      return addOrPatchKey(state, action.quoteId, previousState => ({ ...previousState, [action.key]: action.value }));
    case 'QUOTE_TRADE_SENT':
    case addonActionTypes.ADDON_QUOTE_TRADE_SENT:
    case addonActionTypes.ADDON_QUOTE_REMOVED:
      if (action.type === 'QUOTE_TRADE_SENT' && action.workspace !== 'static' && action.workspace !== 'dynamic') {
        return state;
      }
      return removeKey(state, action.quoteId);
    case 'QUOTE_REMOVED':
      if (action.workspace !== 'static' && action.workspace !== 'dynamic') {
        return state;
      }
      return removeKey(state, action.quoteId);
    case 'QUOTES_REMOVED':
      return removeKeys(state, action.quoteIds);
    default:
      return state;
  }
}
